import { render, staticRenderFns } from "./BtnCreateDetailFile.vue?vue&type=template&id=4bcd3a69&"
import script from "./BtnCreateDetailFile.vue?vue&type=script&lang=ts&"
export * from "./BtnCreateDetailFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports